export default "__VITE_ASSET__CecR7zx5__"